import { Button, Flex, Form, Input, message, Modal } from "antd"
import { UserSwitchOutlined } from "@ant-design/icons"
import { FC, useEffect, useState } from "react"
import SelectAccessPage from "./SelectAccessPage"
import SelectRoles from "./SelectRole"
import { editCustomer } from "../api/customersApi"
import { useActions } from "../../../hooks/useActions"
import { ICustomer } from "../types/customers"
import Password from "./Password"

interface IUserData {
  fullName: string
  email: string
  phoneNumber: string
  password: string
  accessesPages: [string]
  roles: [string]
}

interface IEditUser {
  customer: ICustomer
}

const EditUser: FC<IEditUser> = ({ customer }) => {
  const [form] = Form.useForm()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const { fetchCustomers } = useActions()

  useEffect(() => {
    form.setFieldsValue({
      _id: customer._id,
      fullName: customer.fullName,
      email: customer.email,
      phoneNumber: customer.phoneNumber,
      accessesPages: customer.accessesPages,
      roles: customer.roles,
    })
  }, [customer])

  function openModalWindow() {
    setIsOpen(true)
  }

  function onFinish(values: IUserData) {
    editCustomer({ _id: customer._id, ...values })
      .then((res) => {
        message.success("Edited success")
        fetchCustomers()
      })
      .catch((e) => {
        message.error("Edited error")
      })
      .finally(() => {
        setIsOpen(false)
      })
  }

  const onRolesChange = (value: string[]) => {
    form.setFieldsValue({ roles: value })
  }

  const onAccessPagesChange = (value: string[]) => {
    form.setFieldsValue({ accessesPages: value })
  }

  const setPassword = (value: string) => {
    form.setFieldsValue({ password: value })
  }

  return (
    <>
      <Button
        icon={<UserSwitchOutlined />}
        color="primary"
        variant="outlined"
        onClick={openModalWindow}
      >
        Edit
      </Button>

      <Modal
        title="Create User"
        open={isOpen}
        okText={"Save"}
        onCancel={() => setIsOpen(false)}
        onOk={() => form.submit()}
      >
        <Flex vertical gap="10px">
          <Form form={form} name="control-hooks" onFinish={onFinish} style={{ maxWidth: 600 }}>
            <Form.Item name="fullName" label="Full Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="email" label="Email" rules={[{ required: true }]}>
              <Input />
            </Form.Item>

            <Form.Item name="phoneNumber" label="Phone Number" rules={[{ required: false }]}>
              <Input />
            </Form.Item>

            <Form.Item name="accessesPages" label="Access Pages" rules={[{ required: true }]}>
              <SelectAccessPage
                accesesPage={form.getFieldValue("accessesPages")}
                setAccesesPage={onAccessPagesChange}
              />
            </Form.Item>

            <Form.Item name="roles" label="Roles" rules={[{ required: true }]}>
              <SelectRoles roles={form.getFieldValue("roles")} setRoles={onRolesChange} />
            </Form.Item>
          </Form>
        </Flex>
      </Modal>
    </>
  )
}

export default EditUser
